import { useState } from "react";
import { useForm } from "hooks";
import { LoginType } from "components/form/signin";

export function useSignInForm(defaultEmail = "") {

  const [current, setCurrent] = useState<LoginType>({
    email: defaultEmail,
    password: "",
  });

  const { onChange, onBlur } = useForm({}, undefined, undefined, updateCallback);

  function updateCallback(name: string, value: any) {
    if (name in current) {
      setCurrent((prev) => ({ ...prev, [name]: value }));
    }
  }

  return { current, onBlur, onChange, setCurrent };
}
